import everything from './components/everthing.vue'
import index from './components/index.vue'
import dash from './components/dashboard.vue'
import adminLogin from './components/adminLogin.vue'
import admin from './components/admin.vue'
import login from './components/login.vue'

export default [
  {path: '/dashboard', name: 'dashboard', component: dash},
  {path: '/manage', name: 'index', component: index},
  {path: '/everything', name: 'everything', component: everything},
  {path: '/adminlogin', name: 'adminlogin', component: adminLogin},
  {path: '/admin', name: 'admin', component: admin},
  {path: '/', name: 'login', component: login}
]
